import { DomainError } from '@/errors';

export class BookingAddOnsError extends DomainError {}
